import React, { Component } from "react";
import {
    MDBBtn,
    MDBModalBody,
    MDBModalHeader,
    MDBRow,
    MDBCol,
    MDBCard,
    MDBCardBody,
    MDBSpinner,
    toast
} from "mdbreact";
import Select from "react-select";
import QRCode from "qrcode";
// import axios from "../../../../axios"; // Will be used when real API is implemented
class GenerateWiFiHandout extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            selectedUnits: [],
            handoutType: 'individual', // 'individual' or 'venue'
            includeQRCodes: true,
            selectedVenue: props.venueID || '',
            wifiData: null
        };
        // Better WiFi icon SVG - completely filled design
        this.wifiIconSVG = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#000000" version="1.1" id="Capa_1" width="800px" height="800px" viewBox="0 0 410 410" xml:space="preserve">
<g>
	<g>
		<g>
			<circle cx="205" cy="304.873" r="47.05"/>
			<path d="M205,153.887c-57.634,0-109.614,34.209-132.423,87.155c-5.607,13.018,0.399,28.114,13.415,33.722     c13.018,5.608,28.115-0.396,33.722-13.414c14.692-34.1,48.169-56.136,85.286-56.136s70.594,22.036,85.286,56.136     c4.182,9.707,13.641,15.517,23.581,15.517c3.389,0,6.834-0.674,10.142-2.103c13.019-5.606,19.022-20.704,13.416-33.722     C314.614,188.096,262.634,153.887,205,153.887z"/>
			<path d="M405.797,166.646C361.235,98.664,286.17,58.078,205,58.078S48.765,98.664,4.203,166.646     c-7.771,11.854-4.459,27.761,7.394,35.532c4.338,2.844,9.219,4.203,14.045,4.203c8.362,0,16.561-4.081,21.487-11.598     c35.044-53.461,94.06-85.38,157.871-85.38c63.811,0,122.827,31.918,157.871,85.379c7.77,11.853,23.678,15.166,35.533,7.395     C410.256,194.407,413.567,178.5,405.797,166.646z"/>
		</g>
	</g>
</g>
</svg>`;
    }
    // Fetch WiFi credentials for selected units or entire venue
    fetchWiFiCredentials = async () => {
        this.setState({ loading: true });
        try {
            // Debug: Log unitsList structure to understand available properties
            console.log('unitsList structure:', this.props.unitsList);
            console.log('keyPoolList structure:', this.props.keypoolList);
            if (this.props.unitsList && Object.keys(this.props.unitsList).length > 0) {
                const firstUnit = this.props.unitsList[Object.keys(this.props.unitsList)[0]];
                console.log('First unit properties:', Object.keys(firstUnit));
                console.log('First unit data:', firstUnit);
            }
            // Get SSID from first key in keypoolList
            const ssidName = this.props.keypoolList && this.props.keypoolList.length > 0
                ? this.props.keypoolList[0].ssid || 'DefaultWiFi'
                : 'DefaultWiFi';
            console.log('Using SSID:', ssidName);
            // For now, we'll simulate the data structure based on existing WiFi keys data
            // In production, this would call a specific API endpoint
            // const body = {
            //     AccessToken: sessionStorage.getItem("AccessToken"),
            //     VenueID: this.state.selectedVenue
            // };
            // Simulate API call - replace with actual endpoint when available
            const mockData = {
                venueName: this.props.venueName || "Sample Venue",
                units: this.state.handoutType === 'individual' 
                    ? this.state.selectedUnits
                        .filter(unitKey => {
                            const unit = this.props.unitsList[unitKey];
                            return unit && unit.subscriptions && Object.keys(unit.subscriptions).length > 0;
                        })
                        .map(unitKey => {
                            const unit = this.props.unitsList[unitKey];
                            console.log("PSK:", unit);
                            return {
                                unitID: unit.UnitID,
                                building: unit.Building,
                                floor: unit.Floor,
                                ssid: ssidName, // Use SSID from keyPoolList
                                psk: unit.subscriptions.psk || unit.Password || this.generatePassword(), // Use actual PSK if available
                                security: "WPA2"
                            };
                        })
                    : Object.keys(this.props.unitsList || {})
                        .filter(unitKey => {
                            const unit = this.props.unitsList[unitKey];
                            return unit.subscriptions && Object.keys(unit.subscriptions).length > 0;
                        })
                        .map(unitKey => {
                            const unit = this.props.unitsList[unitKey];
                            return {
                                unitID: unit.UnitID,
                                building: unit.Building, 
                                floor: unit.Floor,
                                ssid: ssidName, // Use SSID from keyPoolList
                                psk:  unit.subscriptions.psk || unit.Password || this.generatePassword(), // Use actual PSK if available
                                security: "WPA2"
                            };
                        })
            };
            this.setState({ wifiData: mockData });
            await this.generateHandout(mockData);
        } catch (error) {
            console.error("Error fetching WiFi credentials:", error);
            toast.error("Failed to fetch WiFi credentials. Please try again.", {
                closeButton: false,
                autoClose: 5000,
            });
        } finally {
            this.setState({ loading: false });
        }
    };
    // Generate a simulated password - remove when real API is available
    generatePassword = () => {
        const chars = 'abcdefghijklmnopqrstuvwxyz0123456789';
        let result = '';
        for (let i = 0; i < 8; i++) {
            result += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        return result;
    };
    // Generate QR code data URL for WiFi credentials
    generateWiFiQR = async (ssid, password, security = "WPA") => {
        try {
            const wifiString = `WIFI:T:${security};S:${ssid};P:${password};H:false;;`;
            const qrDataURL = await QRCode.toDataURL(wifiString, {
                width: 200,
                margin: 2,
                color: {
                    dark: '#000000',
                    light: '#FFFFFF'
                }
            });
            return qrDataURL;
        } catch (error) {
            console.error('Error generating QR code:', error);
            // Return a placeholder if QR generation fails
            return "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNkYPhfDwAChwGA60e6kgAAAABJRU5ErkJggg==";
        }
    };
    // Generate handout document based on the provided design
    generateHandout = async (wifiData) => {
        const { handoutType } = this.state;
        if (handoutType === 'individual') {
            await this.generateIndividualHandouts(wifiData);
        } else {
            await this.generateVenueHandout(wifiData);
        }
    };
    // Generate individual unit handouts matching the provided design
    generateIndividualHandouts = async (wifiData) => {
        const printWindow = window.open('', '_blank');
        let htmlContent = `
            <!DOCTYPE html>
            <html>
            <head>
                <title>Wi-Fi Access Cards</title>
                <meta charset="UTF-8">
                <meta name="viewport" content="width=device-width, initial-scale=1.0">
                <style>
                    @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');
                    * {
                        box-sizing: border-box;
                    }
                    body { 
                        font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', sans-serif; 
                        margin: 0; 
                        padding: 20px;
                        background: #f8f9fa;
                        line-height: 1.5;
                        color: #2c3e50;
                        -webkit-font-smoothing: antialiased;
                        -moz-osx-font-smoothing: grayscale;
                    }
                    .wifi-card { 
                        width: 380px;
                        height: 580px;
                        background: white;
                        margin: 20px auto;
                        padding: 30px;
                        border-radius: 16px;
                        box-shadow: 0 8px 32px rgba(0,0,0,0.12);
                        page-break-after: always;
                        page-break-inside: avoid;
                        display: flex;
                        flex-direction: column;
                        position: relative;
                        border: 1px solid #e3e8ee;
                    }
                    .wifi-card:last-child { 
                        page-break-after: avoid; 
                    }
                    .wifi-icon {
                        text-align: center;
                        margin-bottom: 16px;
                    }
                    .wifi-icon svg {
                        width: 48px;
                        height: 36px;
                        color: #3498db;
                    }
                    .header-title {
                        text-align: center;
                        font-size: 18px;
                        font-weight: 600;
                        color: #2c3e50;
                        margin-bottom: 32px;
                        letter-spacing: 0.5px;
                    }
                    .main-content {
                        display: flex;
                        gap: 24px;
                        flex-grow: 1;
                        min-height: 150px;
                    }
                    .connection-section {
                        flex: 1;
                        display: flex;
                        flex-direction: column;
                        gap: 24px;
                    }
                    .qr-section {
                        width: 140px;
                        text-align: center;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        gap: 8px;
                    }
                    .network-info, .password-info {
                        margin-bottom: 0;
                        text-align: center;
                    }
                    .network-label, .password-label {
                        font-size: 14px;
                        font-weight: 600;
                        color: #7f8c8d;
                        margin-bottom: 6px;
                        text-transform: none;
                        letter-spacing: 0;
                    }
                    .network-name {
                        font-size: 14px;
                        font-weight: 500;
                        color: #2c3e50;
                        background: transparent;
                        padding: 0;
                        border-radius: 0;
                        margin-bottom: 0;
                        border: none;
                        word-break: break-all;
                        line-height: 1.4;
                    }
                    .password-value {
                        font-size: 14px;
                        font-weight: 500;
                        color: #2c3e50;
                        background: transparent;
                        padding: 0;
                        border-radius: 0;
                        letter-spacing: 0;
                        margin-bottom: 0;
                        border: none;
                        font-family: 'Inter', sans-serif;
                        word-break: break-all;
                        line-height: 1.4;
                    }
                    .qr-label {
                        font-size: 11px;
                        color: #95a5a6;
                        margin-bottom: 8px;
                        font-style: normal;
                        font-weight: 400;
                        text-align: center;
                        line-height: 1.3;
                    }
                    .qr-code {
                        width: 120px;
                        height: 120px;
                        border-radius: 8px;
                        border: 1px solid #ecf0f1;
                        display: block;
                    }
                    .footer-section {
                        margin-top: auto;
                        padding-top: 24px;
                        border-top: 1px solid #ecf0f1;
                    }
                    .terms-text {
                        font-size: 9px;
                        color: #95a5a6;
                        text-align: center;
                        line-height: 1.4;
                        margin-bottom: 12px;
                    }
                    .unit-info {
                        font-size: 10px;
                        color: #7f8c8d;
                        text-align: center;
                        margin-bottom: 16px;
                        font-weight: 500;
                        text-transform: none;
                        letter-spacing: 0;
                    }
                    .brand-section {
                        text-align: center;
                    }
                    .brand-logo {
                        font-size: 14px;
                        font-weight: 700;
                        color: #3498db;
                        margin-bottom: 2px;
                        text-transform: none;
                        letter-spacing: 0.5px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        gap: 6px;
                    }
                    .brand-subtitle {
                        font-size: 10px;
                        font-weight: 400;
                        color: #3498db;
                        margin-bottom: 8px;
                        text-transform: uppercase;
                        letter-spacing: 0.5px;
                    }
                    .copyright {
                        font-size: 8px;
                        color: #bdc3c7;
                        text-align: center;
                    }
                    @media print {
                        body { 
                            background: white !important; 
                            padding: 0 !important; 
                        }
                        .wifi-card { 
                            box-shadow: none !important; 
                            margin: 0 auto !important;
                            page-break-inside: avoid !important;
                            border: 1px solid #e3e8ee !important;
                        }
                        @page {
                            margin: 0.5in;
                            size: auto;
                        }
                    }
                    @media screen and (max-width: 480px) {
                        .wifi-card {
                            width: 90%;
                            margin: 10px auto;
                            padding: 20px;
                        }
                        .main-content {
                            flex-direction: column;
                            gap: 16px;
                        }
                        .qr-section {
                            width: 100%;
                        }
                        .header-title {
                            font-size: 16px;
                        }
                    }
                </style>
            </head>
            <body>
        `;
        // Generate QR codes for all units if needed
        const unitsWithQR = await Promise.all(
            wifiData.units?.map(async (unit) => {
                if (this.state.includeQRCodes) {
                    const qrDataURL = await this.generateWiFiQR(unit.ssid, unit.psk, unit.security);
                    return { ...unit, qrCode: qrDataURL };
                }
                return unit;
            }) || []
        );
        unitsWithQR.forEach((unit, index) => {
            htmlContent += `
                <div class="wifi-card">
                    <div class="wifi-icon">
                        ${this.wifiIconSVG}
                    </div>
                    <div class="header-title">CONNECT TO WI-FI</div>
                    <div class="main-content">
                        <div class="connection-section">
                            <div class="network-info">
                                <div class="network-label">Network</div>
                                <div class="network-name">${unit.ssid}</div>
                            </div>
                            <div class="password-info">
                                <div class="password-label">Password</div>
                                <div class="password-value">${unit.psk}</div>
                            </div>
                        </div>
                        ${this.state.includeQRCodes && unit.qrCode ? `
                            <div class="qr-section">
                                <div class="qr-label">or scan here to connect</div>
                                <img src="${unit.qrCode}" alt="WiFi QR Code" class="qr-code" />
                            </div>
                        ` : ''}
                    </div>
                    <div class="footer-section">
                        <div class="terms-text">
                            By connecting you agree to the Wi-Fi Terms of Service found on<br>
                            ${sessionStorage.getItem("PrivacyPolicyURL")}<br>
                            For questions or to request a printout of terms, please contact your<br>
                            property management
                        </div>
                        <div class="unit-info">
                            Building ${unit.building} Floor ${unit.floor} Unit ${unit.unitID}
                        </div>
                        <div class="brand-section">
                            <div class="brand-logo">
                                <img src="${sessionStorage.getItem("logoURL") || sessionStorage.getItem("logo") || "logo.png"}" alt="Logo" style="height: 20px; margin-right: 6px;" />
                                ${sessionStorage.getItem("clientName") || "GROOVE"}
                            </div>
                        </div>
                        <div class="copyright">©2025 ${sessionStorage.getItem("clientName") || "GROOVE"} Technology Solutions. All rights reserved.</div>
                    </div>
                </div>
            `;
        });
        htmlContent += `
            </body>
            </html>
        `;
        printWindow.document.write(htmlContent);
        printWindow.document.close();
        printWindow.focus();
        // Auto-print after content loads
        setTimeout(() => {
            printWindow.print();
        }, 1000);
    };
    // Generate venue-wide handout using individual card format for all units
    generateVenueHandout = async (wifiData) => {
        const printWindow = window.open('', '_blank');
        let htmlContent = `
            <!DOCTYPE html>
            <html>
            <head>
                <title>Wi-Fi Access Cards - ${wifiData.venueName}</title>
                <meta charset="UTF-8">
                <meta name="viewport" content="width=device-width, initial-scale=1.0">
                <style>
                    @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');
                    * {
                        box-sizing: border-box;
                    }
                    body { 
                        font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', sans-serif; 
                        margin: 0; 
                        padding: 20px;
                        background: #f8f9fa;
                        line-height: 1.5;
                        color: #2c3e50;
                        -webkit-font-smoothing: antialiased;
                        -moz-osx-font-smoothing: grayscale;
                    }
                    .wifi-card { 
                        width: 380px;
                        height: 580px;
                        background: white;
                        margin: 20px auto;
                        padding: 30px;
                        border-radius: 16px;
                        box-shadow: 0 8px 32px rgba(0,0,0,0.12);
                        page-break-after: always;
                        page-break-inside: avoid;
                        display: flex;
                        flex-direction: column;
                        position: relative;
                        border: 1px solid #e3e8ee;
                    }
                    .wifi-card:last-child { 
                        page-break-after: avoid; 
                    }
                    .wifi-icon {
                        text-align: center;
                        margin-bottom: 16px;
                    }
                    .wifi-icon svg {
                        width: 48px;
                        height: 36px;
                        color: #3498db;
                    }
                    .header-title {
                        text-align: center;
                        font-size: 18px;
                        font-weight: 600;
                        color: #2c3e50;
                        margin-bottom: 32px;
                        letter-spacing: 0.5px;
                    }
                    .main-content {
                        display: flex;
                        gap: 24px;
                        flex-grow: 1;
                        min-height: 150px;
                    }
                    .connection-section {
                        flex: 1;
                        display: flex;
                        flex-direction: column;
                        gap: 24px;
                    }
                    .qr-section {
                        width: 140px;
                        text-align: center;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        gap: 8px;
                    }
                    .network-info, .password-info {
                        margin-bottom: 0;
                        text-align: center;
                    }
                    .network-label, .password-label {
                        font-size: 14px;
                        font-weight: 600;
                        color: #7f8c8d;
                        margin-bottom: 6px;
                        text-transform: none;
                        letter-spacing: 0;
                    }
                    .network-name {
                        font-size: 14px;
                        font-weight: 500;
                        color: #2c3e50;
                        background: transparent;
                        padding: 0;
                        border-radius: 0;
                        margin-bottom: 0;
                        border: none;
                        word-break: break-all;
                        line-height: 1.4;
                    }
                    .password-value {
                        font-size: 14px;
                        font-weight: 500;
                        color: #2c3e50;
                        background: transparent;
                        padding: 0;
                        border-radius: 0;
                        letter-spacing: 0;
                        margin-bottom: 0;
                        border: none;
                        font-family: 'Inter', sans-serif;
                        word-break: break-all;
                        line-height: 1.4;
                    }
                    .qr-label {
                        font-size: 11px;
                        color: #95a5a6;
                        margin-bottom: 8px;
                        font-style: normal;
                        font-weight: 400;
                        text-align: center;
                        line-height: 1.3;
                    }
                    .qr-code {
                        width: 120px;
                        height: 120px;
                        border-radius: 8px;
                        border: 1px solid #ecf0f1;
                        display: block;
                    }
                    .footer-section {
                        margin-top: auto;
                        padding-top: 24px;
                        border-top: 1px solid #ecf0f1;
                    }
                    .terms-text {
                        font-size: 9px;
                        color: #95a5a6;
                        text-align: center;
                        line-height: 1.4;
                        margin-bottom: 12px;
                    }
                    .unit-info {
                        font-size: 10px;
                        color: #7f8c8d;
                        text-align: center;
                        margin-bottom: 16px;
                        font-weight: 500;
                        text-transform: none;
                        letter-spacing: 0;
                    }
                    .brand-section {
                        text-align: center;
                    }
                    .brand-logo {
                        font-size: 14px;
                        font-weight: 700;
                        color: #3498db;
                        margin-bottom: 2px;
                        text-transform: none;
                        letter-spacing: 0.5px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        gap: 6px;
                    }
                    .brand-subtitle {
                        font-size: 10px;
                        font-weight: 400;
                        color: #3498db;
                        margin-bottom: 8px;
                        text-transform: uppercase;
                        letter-spacing: 0.5px;
                    }
                    .copyright {
                        font-size: 8px;
                        color: #bdc3c7;
                        text-align: center;
                    }
                    @media print {
                        body { 
                            background: white !important; 
                            padding: 0 !important; 
                        }
                        .wifi-card { 
                            box-shadow: none !important; 
                            margin: 0 auto !important;
                            page-break-inside: avoid !important;
                            border: 1px solid #e3e8ee !important;
                        }
                        @page {
                            margin: 0.5in;
                            size: auto;
                        }
                    }
                    @media screen and (max-width: 480px) {
                        .wifi-card {
                            width: 90%;
                            margin: 10px auto;
                            padding: 20px;
                        }
                        .main-content {
                            flex-direction: column;
                            gap: 16px;
                        }
                        .qr-section {
                            width: 100%;
                        }
                        .header-title {
                            font-size: 16px;
                        }
                    }
                </style>
            </head>
            <body>
        `;
        // Generate QR codes for all units if needed
        const unitsWithQR = await Promise.all(
            wifiData.units?.map(async (unit) => {
                if (this.state.includeQRCodes) {
                    const qrDataURL = await this.generateWiFiQR(unit.ssid, unit.psk, unit.security);
                    return { ...unit, qrCode: qrDataURL };
                }
                return unit;
            }) || []
        );
        unitsWithQR.forEach((unit, index) => {
            htmlContent += `
                <div class="wifi-card">
                    <div class="wifi-icon">
                        ${this.wifiIconSVG}
                    </div>
                    <div class="header-title">CONNECT TO WI-FI</div>
                    <div class="main-content">
                        <div class="connection-section">
                            <div class="network-info">
                                <div class="network-label">Network</div>
                                <div class="network-name">${unit.ssid}</div>
                            </div>
                            <div class="password-info">
                                <div class="password-label">Password</div>
                                <div class="password-value">${unit.psk}</div>
                            </div>
                        </div>
                        ${this.state.includeQRCodes && unit.qrCode ? `
                            <div class="qr-section">
                                <div class="qr-label">or scan here to connect</div>
                                <img src="${unit.qrCode}" alt="WiFi QR Code" class="qr-code" />
                            </div>
                        ` : ''}
                    </div>
                    <div class="footer-section">
                        <div class="terms-text">
                            By connecting you agree to the Wi-Fi Terms of Service found on<br>
                            ${sessionStorage.getItem("PrivacyPolicyURL")}<br>
                            For questions or to request a printout of terms, please contact your<br>
                            property management
                        </div>
                        <div class="unit-info">
                            Building ${unit.building} Floor ${unit.floor} Unit ${unit.unitID}
                        </div>
                        <div class="brand-section">
                            <div class="brand-logo">
                                <img src="${sessionStorage.getItem("logoURL") || sessionStorage.getItem("logo") || "logo.png"}" alt="Logo" style="height: 20px; margin-right: 6px;" />
                                ${sessionStorage.getItem("clientName") || "GROOVE"}
                            </div>
                        </div>
                        <div class="copyright">©2025 ${sessionStorage.getItem("clientName") || "GROOVE"} Technology Solutions. All rights reserved.</div>
                    </div>
                </div>
            `;
        });
        htmlContent += `
            </body>
            </html>
        `;
        printWindow.document.write(htmlContent);
        printWindow.document.close();
        printWindow.focus();
        setTimeout(() => {
            printWindow.print();
        }, 1000);
    };
    handleUnitSelection = (selectedOptions) => {
        // console.log('handleUnitSelection called with:', selectedOptions);
        // React-select returns an array of option objects for multiple selection
        // Extract just the values
        const selectedValues = selectedOptions ? selectedOptions.map(option => option.value) : [];
        // console.log('Extracted values:', selectedValues);
        this.setState({ selectedUnits: selectedValues });
    };
    render() {
        const { loading, handoutType, includeQRCodes } = this.state;
        // Prepare unit options for dropdown - only show units with subscriptions
        // console.log(this.props.unitsList)
        const unitOptions = this.props.unitsList 
            ? Object.keys(this.props.unitsList)
                .filter(key => {
                    const unit = this.props.unitsList[key];
                    return unit && unit.subscriptions && Object.keys(unit.subscriptions).length > 0;
                })
                .map(key => ({
                    value: key,
                    label: `Unit ${this.props.unitsList[key].UnitID} - Building ${this.props.unitsList[key].Building} - Floor ${this.props.unitsList[key].Floor}`
                })) 
            : [];
        // Debug logging to help troubleshoot dropdown issues
        // console.log('GenerateWiFiHandout - unitsList:', this.props);
        // console.log('GenerateWiFiHandout - unitOptions:', unitOptions);
        // console.log('GenerateWiFiHandout - selectedUnits:', this.state.selectedUnits);
        // Check if all units are selected
        const allUnitsSelected = unitOptions.length > 0 && this.state.selectedUnits.length === unitOptions.length;
        return (
            <>
                <MDBModalHeader toggle={this.props.toggle}>
                    <h4>Generate Wi-Fi Access Handouts</h4>
                    <p>Create printable Wi-Fi password handouts for units or entire venue</p>
                </MDBModalHeader>
                <MDBModalBody>
                    <MDBRow>
                        <MDBCol md="12">
                            <div style={{ marginBottom: '20px', padding: '15px', background: '#e8f4f8', border: '1px solid #bee5eb', borderRadius: '8px' }}>
                                <small style={{ color: '#0c5460', fontWeight: '500' }}>
                                    <i className="fas fa-info-circle" style={{ marginRight: '8px' }}></i>
                                    Handouts will only be generated for units with active Wi-Fi subscriptions.
                                </small>
                            </div>
                            <MDBCard>
                                <MDBCardBody>
                                    <h5>Handout Type</h5>
                                    <div style={{ marginBottom: '20px' }}>
                                        <label style={{ 
                                            display: 'block', 
                                            marginBottom: '10px', 
                                            padding: '12px 16px',
                                            border: handoutType === 'individual' ? '2px solid #007bff' : '2px solid #e9ecef',
                                            borderRadius: '8px',
                                            backgroundColor: handoutType === 'individual' ? '#f8f9ff' : '#ffffff',
                                            cursor: 'pointer',
                                            transition: 'all 0.2s ease-in-out',
                                            boxShadow: handoutType === 'individual' ? '0 2px 8px rgba(0, 123, 255, 0.15)' : 'none'
                                        }}>
                                            <input
                                                type="radio"
                                                value="individual"
                                                checked={handoutType === 'individual'}
                                                onChange={(e) => this.setState({ handoutType: e.target.value })}
                                                style={{ marginRight: '12px', transform: 'scale(1.2)' }}
                                            />
                                            <strong style={{ color: handoutType === 'individual' ? '#007bff' : '#495057' }}>
                                                Individual Unit Cards
                                            </strong>
                                            <div style={{ 
                                                fontSize: '14px', 
                                                color: handoutType === 'individual' ? '#6c757d' : '#6c757d',
                                                marginTop: '4px',
                                            }}>
                                                Generate handout cards for selected units with subscriptions only
                                            </div>
                                        </label>
                                        <label style={{ 
                                            display: 'block',
                                            padding: '12px 16px',
                                            border: handoutType === 'venue' ? '2px solid #007bff' : '2px solid #e9ecef',
                                            borderRadius: '8px',
                                            backgroundColor: handoutType === 'venue' ? '#f8f9ff' : '#ffffff',
                                            cursor: 'pointer',
                                            transition: 'all 0.2s ease-in-out',
                                            boxShadow: handoutType === 'venue' ? '0 2px 8px rgba(0, 123, 255, 0.15)' : 'none'
                                        }}>
                                            <input
                                                type="radio"
                                                value="venue"
                                                checked={handoutType === 'venue'}
                                                onChange={(e) => this.setState({ handoutType: e.target.value })}
                                                style={{ marginRight: '12px', transform: 'scale(1.2)' }}
                                            />
                                            <strong style={{ color: handoutType === 'venue' ? '#007bff' : '#495057' }}>
                                                All Units
                                            </strong>
                                            <div style={{ 
                                                fontSize: '14px', 
                                                color: handoutType === 'venue' ? '#6c757d' : '#6c757d',
                                                marginTop: '4px',
                                            }}>
                                                Generate handout cards for all units with subscriptions in the venue
                                            </div>
                                        </label>
                                    </div>
                                    {handoutType === 'individual' && (
                                        <div style={{ marginBottom: '20px' }}>
                                            <h5>Select Units</h5>
                                            <Select
                                                options={unitOptions}
                                                value={unitOptions.filter(option => this.state.selectedUnits.includes(option.value))}
                                                isMulti
                                                isSearchable
                                                placeholder="Choose units for individual handout cards..."
                                                onChange={this.handleUnitSelection}
                                                closeMenuOnSelect={false}
                                                styles={{
                                                    control: (provided) => ({
                                                        ...provided,
                                                        minHeight: '38px'
                                                    }),
                                                    multiValue: (provided) => ({
                                                        ...provided,
                                                        backgroundColor: '#007bff',
                                                        color: 'white'
                                                    }),
                                                    multiValueLabel: (provided) => ({
                                                        ...provided,
                                                        color: 'white'
                                                    }),
                                                    multiValueRemove: (provided) => ({
                                                        ...provided,
                                                        color: 'white',
                                                        ':hover': {
                                                            backgroundColor: '#0056b3',
                                                            color: 'white'
                                                        }
                                                    })
                                                }}
                                            />
                                            <div style={{ marginTop: '8px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                <small style={{ color: '#666' }}>
                                                    Select multiple units. Use the search box to filter options.
                                                </small>
                                                <div>
                                                    {unitOptions.length > 0 && !allUnitsSelected && (
                                                        <MDBBtn 
                                                            size="sm" 
                                                            color="primary" 
                                                            onClick={() => this.setState({ selectedUnits: unitOptions.map(option => option.value) })}
                                                            style={{ padding: '4px 8px', fontSize: '12px', marginRight: '8px' }}
                                                        >
                                                            Select All
                                                        </MDBBtn>
                                                    )}
                                                    {this.state.selectedUnits.length > 0 && (
                                                        <MDBBtn 
                                                            size="sm" 
                                                            color="secondary" 
                                                            onClick={() => this.setState({ selectedUnits: [] })}
                                                            style={{ padding: '4px 8px', fontSize: '12px' }}
                                                        >
                                                            Clear All ({this.state.selectedUnits.length})
                                                        </MDBBtn>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                    {/* <div style={{ marginBottom: '20px' }}>
                                        <label style={{ display: 'block' }}>
                                            <input
                                                type="checkbox"
                                                checked={includeQRCodes}
                                                onChange={(e) => this.setState({ includeQRCodes: e.target.checked })}
                                                style={{ marginRight: '8px' }}
                                            />
                                            Include QR codes for automatic connection
                                        </label>
                                        <small style={{ color: '#666', marginTop: '5px', display: 'block' }}>
                                            QR codes allow users to connect automatically by scanning with their device camera.
                                        </small>
                                    </div> */}
                                    <div className="text-center">
                                        <MDBBtn
                                            color="primary"
                                            onClick={this.fetchWiFiCredentials}
                                            disabled={loading || (handoutType === 'individual' && this.state.selectedUnits.length === 0)}
                                        >
                                            {loading ? (
                                                <>
                                                    <MDBSpinner size="sm" /> Generating...
                                                </>
                                            ) : (
                                                'Generate Handouts'
                                            )}
                                        </MDBBtn>
                                        <MDBBtn
                                            color="primary"
                                            onClick={this.props.toggle}
                                            style={{ marginLeft: '10px' }}
                                        >
                                            Cancel
                                        </MDBBtn>
                                    </div>
                                    {/* <div style={{ marginTop: '20px', padding: '15px', background: '#f8f9fa', borderRadius: '8px' }}>
                                        <small style={{ color: '#666' }}>
                                            <strong>✅ QR Codes:</strong> Functional Wi-Fi QR codes are now generated for automatic device connection. 
                                            Users can scan the QR code with their camera to connect instantly without typing passwords.
                                        </small>
                                    </div> */}
                                </MDBCardBody>
                            </MDBCard>
                        </MDBCol>
                    </MDBRow>
                </MDBModalBody>
            </>
        );
    }
}
export default GenerateWiFiHandout;
